class QuickAdd extends HTMLElement {
    constructor() {
      super();
      const dataTag = this.querySelector('.product-data');
      this.product = JSON.parse(dataTag.textContent);
      this.variants = this.product.variants;
    }
  
    connectedCallback() {
      this.form = this.querySelector('product-form form');
      this.variantInput = this.querySelector('.variant-id');
  
      this.querySelectorAll('.option-button').forEach(button => {
        button.addEventListener('click', () => {
          this.selectAndSubmit(button);
        });
      });
    }
  
    selectAndSubmit(button) {
      const value = button.dataset.optionValue;
  
      const matchedVariant = this.variants.find(v =>
        v.options[0] === value && v.available
      );
  
      if (matchedVariant) {
        this.variantInput.value = matchedVariant.id;
  
        this.querySelectorAll('.option-button').forEach(b => b.classList.remove('active'));
        button.classList.add('active');
  
        this.form.requestSubmit?.();
      } else {
        this.variantInput.value = '';
      }
    }
  }
  
  customElements.define('quick-add', QuickAdd);
  